import type { SVGProps } from "react";
import * as React from "react";
const SvgFullscreenExit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.414 9H19v2h-6V5h2v2.586l4.293-4.293 1.414 1.414L16.414 9ZM9 16.414l-4.293 4.293-1.414-1.414L7.586 15H5v-2h6v6H9v-2.586Z"
    />
  </svg>
);
export default SvgFullscreenExit;
